import { FieldErrors, get, useFormContext } from 'react-hook-form'

export interface FormErrorMessageProps {
  errors: FieldErrors
  name: string
  'data-testid': string
}

export default function FormErrorMessage({
  errors,
  name,
  'data-testid': testId
}: Readonly<FormErrorMessageProps>) {
  const methods = useFormContext()
  const error = get(errors || methods.formState.errors, name)

  if (!error) {
    return null
  }

  return (
    <span className="text-red-500 dark:text-red-400" data-testid={testId}>
      {error.message}
    </span>
  )
}
